"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CurrencyYen = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "currency-yen" },
            react_1.default.createElement("path", { id: "Icon", d: "M11 20.5C11 21.0523 11.4477 21.5 12 21.5C12.5523 21.5 13 21.0523 13 20.5H11ZM19.2762 4.1306C19.6245 3.70197 19.5594 3.07216 19.1307 2.72389C18.7021 2.37562 18.0723 2.44077 17.724 2.8694L19.2762 4.1306ZM6.27624 2.86942C5.92798 2.44078 5.29818 2.37562 4.86954 2.72388C4.4409 3.07214 4.37574 3.70194 4.724 4.13058L6.27624 2.86942ZM18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5V12.5ZM5.99998 10.5C5.4477 10.5 4.99998 10.9477 4.99998 11.5C4.99998 12.0523 5.4477 12.5 5.99998 12.5V10.5ZM17 16.5C17.5523 16.5 18 16.0523 18 15.5C18 14.9477 17.5523 14.5 17 14.5V16.5ZM6.99998 14.5C6.4477 14.5 5.99998 14.9477 5.99998 15.5C5.99998 16.0523 6.4477 16.5 6.99998 16.5V14.5ZM13 20.5V11.5H11V20.5H13ZM17.724 2.8694L11.2239 10.8694L12.7761 12.1306L19.2762 4.1306L17.724 2.8694ZM12.7761 10.8694L6.27624 2.86942L4.724 4.13058L11.2239 12.1306L12.7761 10.8694ZM18 10.5H5.99998V12.5H18V10.5ZM17 14.5H6.99998V16.5H17V14.5Z" }))));
};
exports.default = CurrencyYen;
